export default {
  en: {
    "piano-roll": "Piano Roll",
    tempo: "Tempo",
    "time-signature": "Time Signature",
    "add-time-signature": "Add Time Signature",
    "remove-time-signature": "Remove Time Signature",
    file: "File",
    edit: "Edit",
    "new-song": "New",
    "open-song": "Open",
    "save-song": "Save",
    "save-as": "Save As",
    "song-created": "Song created",
    "song-saving": "Saving song...",
    "song-saved": "Song saved",
    "download-midi": "Download MIDI File",
    "untitled-song": "Untitled song",
    name: "Name",
    rename: "Rename",
    track: "Track",
    "add-track": "Add Track",
    "delete-track": "Delete Track",
    "duplicate-track": "Duplicate Track",
    channel: "Channel",
    categories: "Categories",
    instruments: "Instruments",
    "rhythm-track": "Rhythm Track",
    "conductor-track": "Conductor Track",
    "track-name": "Track Name",
    "midi-routing": "Routing",
    "midi-routing-selected-track": "Active Track",
    "midi-routing-selected-track-description":
      "Routes all MIDI input to the currently selected track",
    "midi-routing-channel": "Multi Track",
    "midi-routing-channel-description":
      "Routes input to tracks by MIDI channel for simultaneous multi-track recording",
    cancel: "Cancel",
    insert: "Insert",
    ok: "OK",
    reset: "Reset",
    triplet: "Triplet",
    dotted: "Dotted",
    "confirm-new":
      "Your edits have not been saved. Are you sure you want to continue?",
    "confirm-open":
      "Your edits have not been saved. Are you sure you want to continue?",
    "confirm-close":
      "Your edits have not been saved. Be sure to download it before exiting. Do you really want to close it?",
    "auto-scroll": "Auto Scroll",
    help: "Help",
    close: "Close",
    "keyboard-shortcut": "Keyboard Shortcut",
    "play-pause": "Play/Pause",
    rewind: "Rewind",
    "fast-forward": "Fast Forward",
    "forward-rewind": "Rewind / Forward",
    "start-stop-recording": "Start/Stop Recording",
    "next-previous-track": "Next Track / Previous Track",
    "solo-mute-ghost": "Solo, Mute or Ghost Track",
    stop: "Stop",
    record: "Record",
    "pencil-tool": "Pencil Tool",
    "selection-tool": "Selection Tool",
    "control-pencil-tool": "Free",
    "control-single-tool": "Single",
    "control-line-tool": "Line",
    "control-curve-tool": "Curve",
    "curve-ease-in": "Acceleration Curve",
    "curve-ease-out": "Deceleration Curve",
    "copy-selection": "Copy Selection",
    "cut-selection": "Cut Selection",
    "paste-selection": "Paste Selection",
    "select-all": "Select All",
    "select-next": "Select Next",
    "select-previous": "Select Previous",
    "delete-selection": "Delete Selection",
    "move-selection": "Move Selection",
    undo: "Undo",
    redo: "Redo",
    cut: "Cut",
    copy: "Copy",
    copied: "Copied",
    paste: "Paste",
    duplicate: "Duplicate",
    delete: "Delete",
    "song-deleted": "Song deleted",
    "song-delete-failed": "Song delete failed",
    "select-note": "Select Note",
    "scroll-horizontally": "Scroll Horizontally",
    "scroll-vertically": "Scroll Vertically",
    settings: "Settings",
    language: "Language",
    theme: "Theme",
    "midi-settings": "MIDI Settings",
    inputs: "Inputs",
    outputs: "Outputs",
    "no-inputs": "No input devices found",
    "one-octave-up": "+1 Oct",
    "one-octave-down": "-1 Oct",
    arrange: "Arrange",
    "arrangement-view": "Arrangement View",
    "open-help": "Open Help",
    "event-list": "Event List",
    "open-chat": "Open Chat",
    property: "Property",
    quantize: "Quantize",
    "snap-to-grid": "Snap to Grid",
    "export-audio": "Export Audio",
    export: "Export",
    "exporting-audio": "Exporting audio...",
    "file-type": "File Type",
    "export-error-too-short": "Song is too short",
    "set-loop-start": "Set Loop Start",
    "set-loop-end": "Set Loop End",
    "switch-tab": "Switch Tab",
    transpose: "Transpose",
    yes: "Yes",
    no: "No",
    "please-sign-up": "Sign up to use cloud save",
    "save-changes": "Do you want to save your changes to the song?",
    "sign-in": "Sign In",
    "sign-out": "Sign Out",
    "success-sign-in": "Successfully signed in",
    files: "Files",
    "created-date": "Created",
    "modified-date": "Modified",
    "cloud-beta-warning":
      "Since the cloud function is in beta during development, please download and save your important songs frequently.",
    "cloud-description":
      "By signing in, you can save your music to the cloud and resume composing from anywhere at any time.",
    "import-midi": "Import MIDI",
    "export-midi": "Export MIDI",
    general: "General",
    appearance: "Appearance",
    "change-track-color": "Change Track Color",
    "control-settings": "Control Settings",
    "show-note-labels": "Show Note Labels",
    add: "Add",
    remove: "Remove",
    "initialize-error": "Error occured in launch process",
    "soundfont-save-notice": "SoundFont will be saved in the browser.",
    "loading-external-midi": "Loading external MIDI file...",
    initializing: "Initializing...",
    profile: "Profile",
    "publish-notice":
      "Publishing your song makes it available for other users to listen to.",
    "published-notice":
      "Your song is published and available for other users to listen to.",
    publish: "Publish",
    unpublish: "Unpublish",
    "publish-song": "Publish Song",
    "song-published": "Song published",
    "song-unpublished": "Song unpublished",
    "share-my-song-text":
      "🎶 Just created a new track on signal! 🎹✨\nListen to my latest MIDI composition! 🎧👇\n#midi #signalmidi @signalmidi",
    "publish-rules":
      "Important Notice: On this site, we only permit the posting of music that you have created yourself. In compliance with copyright laws, please ensure that you are the copyright holder or have explicit permission for any music you post. Unauthorized publication of others' music or copyright-protected works is legally prohibited. If such violations are detected, your post may be removed, and restrictions may be placed on your account. We encourage you to share creative and original works and contribute to the healthy growth of our community.",
    "soundfont-location": "Location",
    "loading-file": "Loading file...",
    soundfont: "SoundFont",
    scan: "Scan",
    midi: "MIDI",
    "no-files": "No files",
    "restore-defaults": "Restore Defaults",
    "user-settings": "User Settings",
    "delete-account": "Delete Account",
    "delete-account-description":
      "All songs and accounts stored in the cloud will be deleted. Once deleted, the data cannot be restored. If you really want to execute the deletion, press the Delete button.",
    /* AutoSaveDialog */
    "auto-save-dialog-title": "Restore Auto Saved Song",
    "auto-save-dialog-description":
      "An auto-saved song from your last session was found. Do you want to restore it?",
    "auto-save-dialog-last-save-time": "Last saved at:",
    "auto-save-dialog-restore": "Restore",
    "auto-save-dialog-delete": "Delete",
    /* MIDI Instrument Categories */
    Piano: "Piano",
    "Chromatic Percussion": "Chromatic Percussion",
    Organ: "Organ",
    Guitar: "Guitar",
    Bass: "Bass",
    Strings: "Strings",
    Ensemble: "Ensemble",
    Brass: "Brass",
    Reed: "Reed",
    Pipe: "Pipe",
    "Synth Lead": "Synth Lead",
    "Synth Pad": "Synth Pad",
    "Synth Effects": "Synth Effects",
    Ethnic: "Ethnic",
    Percussive: "Percussive",
    "Sound Effects": "Sound Effects",
    "Drum Kits": "Drum Kits",
    /* MIDI Instruments */
    "Acoustic Grand Piano": "Acoustic Grand Piano",
    "Bright Acoustic Piano": "Bright Acoustic Piano",
    "Electric Grand Piano": "Electric Grand Piano",
    "Honky-tonk Piano": "Honky-tonk Piano",
    "Electric Piano 1": "Electric Piano 1",
    "Electric Piano 2": "Electric Piano 2",
    Harpsichord: "Harpsichord",
    Clavinet: "Clavinet",
    Celesta: "Celesta",
    Glockenspiel: "Glockenspiel",
    "Music Box": "Music Box",
    Vibraphone: "Vibraphone",
    Marimba: "Marimba",
    Xylophone: "Xylophone",
    "Tubular Bells": "Tubular Bells",
    Dulcimer: "Dulcimer",
    "Drawbar Organ": "Drawbar Organ",
    "Percussive Organ": "Percussive Organ",
    "Rock Organ": "Rock Organ",
    "Church Organ": "Church Organ",
    "Reed Organ": "Reed Organ",
    Accordion: "Accordion",
    Harmonica: "Harmonica",
    "Tango Accordion": "Tango Accordion",
    "Acoustic Guitar (nylon)": "Acoustic Guitar (nylon)",
    "Acoustic Guitar (steel)": "Acoustic Guitar (steel)",
    "Electric Guitar (jazz)": "Electric Guitar (jazz)",
    "Electric Guitar (clean)": "Electric Guitar (clean)",
    "Electric Guitar (muted)": "Electric Guitar (muted)",
    "Overdriven Guitar": "Overdriven Guitar",
    "Distortion Guitar": "Distortion Guitar",
    "Guitar Harmonics": "Guitar Harmonics",
    "Acoustic Bass": "Acoustic Bass",
    "Electric Bass (finger)": "Electric Bass (finger)",
    "Electric Bass (pick)": "Electric Bass (pick)",
    "Fretless Bass": "Fretless Bass",
    "Slap Bass 1": "Slap Bass 1",
    "Slap Bass 2": "Slap Bass 2",
    "Synth Bass 1": "Synth Bass 1",
    "Synth Bass 2": "Synth Bass 2",
    Violin: "Violin",
    Viola: "Viola",
    Cello: "Cello",
    Contrabass: "Contrabass",
    "Tremolo Strings": "Tremolo Strings",
    "Pizzicato Strings": "Pizzicato Strings",
    "Orchestral Harp": "Orchestral Harp",
    Timpani: "Timpani",
    "String Ensemble 1": "String Ensemble 1",
    "String Ensemble 2": "String Ensemble 2",
    "Synth Strings 1": "Synth Strings 1",
    "Synth Strings 2": "Synth Strings 2",
    "Choir Aahs": "Choir Aahs",
    "Voice Oohs": "Voice Oohs",
    "Synth Choir": "Synth Choir",
    "Orchestra Hit": "Orchestra Hit",
    Trumpet: "Trumpet",
    Trombone: "Trombone",
    Tuba: "Tuba",
    "Muted Trumpet": "Muted Trumpet",
    "French Horn": "French Horn",
    "Brass Section": "Brass Section",
    "Synth Brass 1": "Synth Brass 1",
    "Synth Brass 2": "Synth Brass 2",
    "Soprano Sax": "Soprano Sax",
    "Alto Sax": "Alto Sax",
    "Tenor Sax": "Tenor Sax",
    "Baritone Sax": "Baritone Sax",
    Oboe: "Oboe",
    "English Horn": "English Horn",
    Bassoon: "Bassoon",
    Clarinet: "Clarinet",
    Piccolo: "Piccolo",
    Flute: "Flute",
    Recorder: "Recorder",
    "Pan Flute": "Pan Flute",
    "Blown Bottle": "Blown Bottle",
    Shakuhachi: "Shakuhachi",
    Whistle: "Whistle",
    Ocarina: "Ocarina",
    "Lead 1 (square)": "Lead 1 (square)",
    "Lead 2 (sawtooth)": "Lead 2 (sawtooth)",
    "Lead 3 (calliope)": "Lead 3 (calliope)",
    "Lead 4 (chiff)": "Lead 4 (chiff)",
    "Lead 5 (charang)": "Lead 5 (charang)",
    "Lead 6 (voice)": "Lead 6 (voice)",
    "Lead 7 (fifths)": "Lead 7 (fifths)",
    "Lead 8 (bass + lead)": "Lead 8 (bass + lead)",
    "Pad 1 (new age)": "Pad 1 (new age)",
    "Pad 2 (warm)": "Pad 2 (warm)",
    "Pad 3 (polysynth)": "Pad 3 (polysynth)",
    "Pad 4 (choir)": "Pad 4 (choir)",
    "Pad 5 (bowed)": "Pad 5 (bowed)",
    "Pad 6 (metallic)": "Pad 6 (metallic)",
    "Pad 7 (halo)": "Pad 7 (halo)",
    "Pad 8 (sweep)": "Pad 8 (sweep)",
    "FX 1 (rain)": "FX 1 (rain)",
    "FX 2 (soundtrack)": "FX 2 (soundtrack)",
    "FX 3 (crystal)": "FX 3 (crystal)",
    "FX 4 (atmosphere)": "FX 4 (atmosphere)",
    "FX 5 (brightness)": "FX 5 (brightness)",
    "FX 6 (goblins)": "FX 6 (goblins)",
    "FX 7 (echoes)": "FX 7 (echoes)",
    "FX 8 (sci-fi)": "FX 8 (sci-fi)",
    Sitar: "Sitar",
    Banjo: "Banjo",
    Shamisen: "Shamisen",
    Koto: "Koto",
    Kalimba: "Kalimba",
    Bagpipe: "Bagpipe",
    Fiddle: "Fiddle",
    Shanai: "Shanai",
    "Tinkle Bell": "Tinkle Bell",
    Agogo: "Agogo",
    "Steel Drums": "Steel Drums",
    Woodblock: "Woodblock",
    "Taiko Drum": "Taiko Drum",
    "Melodic Tom": "Melodic Tom",
    "Synth Drum": "Synth Drum",
    "Reverse Cymbal": "Reverse Cymbal",
    "Guitar Fret Noise": "Guitar Fret Noise",
    "Breath Noise": "Breath Noise",
    Seashore: "Seashore",
    "Bird Tweet": "Bird Tweet",
    "Telephone Ring": "Telephone Ring",
    Helicopter: "Helicopter",
    Applause: "Applause",
    Gunshot: "Gunshot",
    /* Drum Kit Instruments */
    "Standard Drum Kit": "Standard Drum Kit",
    "Room Drum Kit": "Room Drum Kit",
    "Power Drum Kit": "Power Drum Kit",
    "Electronic Drum Kit": "Electronic Drum Kit",
    "Analog Drum Kit": "Analog Drum Kit",
    "Jazz Drum Kit": "Jazz Drum Kit",
    "Brush Drum Kit": "Brush Drum Kit",
    "Orchestra Drum Kit": "Orchestra Drum Kit",
    "SFX Drum Kit": "SFX Drum Kit",
    /* */
    velocity: "Velocity",
    "pitch-bend": "Pitch Bend",
    volume: "Volume",
    panpot: "Panpot",
    expression: "Expression",
    "hold-pedal": "Hold Pedal",
    pan: "Pan",
    event: "Event",
    duration: "Duration",
    tick: "Tick",
    value: "Value",
    key: "Key",
    scale: "Scale",
    "show-scale": "Show Scale",
    "hide-scale": "Hide Scale",
    /* Scale */
    "scale-major": "Major",
    "scale-minor": "Minor",
    "scale-harmonic-minor": "Harmonic Minor",
    "scale-harmonic-major": "Harmonic Major",
    "scale-melodic-minor": "Melodic Minor",
    "scale-ionian": "Ionian",
    "scale-dorian": "Dorian",
    "scale-phrygian": "Phrygian",
    "scale-lydian": "Lydian",
    "scale-mixolydian": "Mixolydian",
    "scale-aeolian": "Aeolian",
    "scale-locrian": "Locrian",
    "scale-major-pentatonic": "Major Pentatonic",
    "scale-minor-pentatonic": "Minor Pentatonic",
    "scale-major-blues": "Major Blues",
    "scale-minor-blues": "Minor Blues",
    "scale-half-whole-diminished": "Half-whole Diminished",
    "scale-whole-half-diminished": "Whole-half Diminished",
    "scale-whole-tone": "Whole Tone",
    /* operation */
    "operation-set": "Set",
    "operation-add": "Add",
    "operation-multiply": "Multiply",
  },
  fr: {
    "piano-roll": "Rouleau de piano",
    tempo: "Tempo",
    "time-signature": "Indication de mesure",
    "add-time-signature": "Ajouter une indication de mesure",
    "remove-time-signature": "Enlever une indication de mesure",
    file: "Fichier",
    edit: "Édition",
    "new-song": "Nouveau",
    "open-song": "Ouvrir",
    "save-song": "Enregistrer",
    "save-as": "Enregistrer sous",
    "song-created": "Musique créée",
    "song-saving": "Enregistement de la musique...",
    "song-saved": "Musique enregistrée",
    "download-midi": "Télécharger le fichier midi",
    "untitled-song": "Musique sans titre",
    name: "Nom",
    rename: "Renommer",
    track: "Piste",
    "add-track": "Ajouter une piste",
    "delete-track": "Supprimer la piste",
    "duplicate-track": "Dupliquer la piste",
    channel: "Chaîne",
    categories: "Catégories",
    instruments: "Instruments",
    "rhythm-track": "Piste de Rythme",
    "conductor-track": "Piste Conductrice",
    "track-name": "Nom de la Piste",
    "midi-routing": "Routage",
    "midi-routing-selected-track": "Piste active",
    "midi-routing-selected-track-description":
      "Envoie toutes les entrées MIDI à la piste actuellement sélectionnée",
    "midi-routing-channel": "Multi-piste",
    "midi-routing-channel-description":
      "Achemine les entrées vers les pistes par canal MIDI pour l'enregistrement simultané",
    cancel: "Annuler",
    insert: "Insérer",
    ok: "OK",
    reset: "Réinitialiser",
    triplet: "Triolet",
    dotted: "Pointillé",
    "confirm-new":
      "Vos modifications n'ont pas été enregistrées. Êtes-vous sûr(e) de vouloir continuer?",
    "confirm-open":
      "Vos modifications n'ont pas été enregistrées. Êtes-vous sûr(e) de vouloir continuer?",
    "confirm-close":
      "Vos modifications n'ont pas été enregistrées. Téléchargez-le avant de le fermer. Êtes-vous sûr(e) de vouloir quitter?",
    "auto-scroll": "Défilement Automatique",
    help: "Aide",
    close: "Fermer",
    "keyboard-shortcut": "Raccourcis Clavier",
    "play-pause": "Lecture/Pause",
    rewind: "Rembobiner",
    "fast-forward": "Avance Rapide",
    "forward-rewind": "Rembobiner / Avancer",
    "start-stop-recording": "Commencer/Arrêter l'enregistrement",
    "next-previous-track": "Piste Suivante / Piste Précédente",
    "solo-mute-ghost": "Mêttre la Piste en Solo/Muet ou Masquer",
    stop: "Stop",
    record: "Enregistrer",
    "pencil-tool": "Outil Crayon",
    "selection-tool": "Outil de Sélection",
    "control-pencil-tool": "Libre",
    "control-single-tool": "Simple",
    "control-line-tool": "Ligne",
    "control-curve-tool": "Courbe",
    "curve-ease-in": "Courbe d'accélération",
    "curve-ease-out": "Courbe de décélération",
    "copy-selection": "Copier les éléments sélectionnés",
    "cut-selection": "Couper les éléments sélectionnés",
    "paste-selection": "Coller les éléments sélectionnés",
    "select-all": "Tout sélectionnés",
    "select-next": "Selectionner le prochain",
    "select-previous": "Selectionner la précédente",
    "delete-selection": "Supprimer les éléments sélectionnés",
    "move-selection": "Déplacer la Sélection",
    undo: "Annuler",
    redo: "Rétablir",
    cut: "Couper",
    copy: "Copier",
    copied: "Copié",
    paste: "Coller",
    duplicate: "Dupliquer",
    delete: "Supprimer",
    "song-deleted": "Morceaux supprimé",
    "song-delete-failed": "Suppression du morceaux échouée",
    "select-note": "Selectionner la note",
    "scroll-horizontally": "Défiler horizontalement",
    "scroll-vertically": "Défiler verticalement",
    settings: "Paramètres",
    language: "Langue",
    theme: "Thème",
    "midi-settings": "Paramètres MIDI",
    inputs: "Entrées",
    outputs: "Sorties",
    "no-inputs": "Pas d'entrées trouvées",
    "one-octave-up": "+1 Octave",
    "one-octave-down": "-1 Octave",
    arrange: "Arranger",
    "arrangement-view": "Vue de l'Arrangement",
    "open-help": "Ouvrir l'Aide",
    "event-list": "Liste des Évenements",
    "open-chat": "Ouvrir le Chat",
    property: "Propriété",
    quantize: "Quantifier",
    "snap-to-grid": "Aimanter à la grille",
    "export-audio": "Exporter l'Audio",
    export: "Exporter",
    "exporting-audio": "Exportation de l'audio...",
    "file-type": "Type de Fichier",
    "export-error-too-short": "Song is too short",
    "set-loop-start": "Mêttre le début de la boucle",
    "set-loop-end": "Mêttre la fin de la boucle",
    "switch-tab": "Changer d'onglet",
    transpose: "Transposer",
    yes: "Oui",
    no: "Non",
    "please-sign-up":
      "Connectez-vous pour enregistrer vos morceaux sur le cloud",
    "save-changes": "Voulez-vous enregistrer vos modifications?",
    "sign-in": "Se Connecter",
    "sign-out": "Se Déconnecter",
    "success-sign-in": "Connecté avec succès",
    files: "Fichiers",
    "created-date": "Créé",
    "modified-date": "Modifié",
    "cloud-beta-warning":
      "Étant donné que la fonction cloud est en développement, veuillez télécharger et enregistrer fréquemment vos chansons importantes.",
    "cloud-description":
      "By signing in, you can save your music to the cloud and resume composing from anywhere at any time.",
    "import-midi": "Importer un fichier MIDI",
    "export-midi": "Exporter un fichier MIDI",
    general: "General",
    appearance: "Appearance",
    "change-track-color": "Changer la couleur de la piste",
    "control-settings": "Paramètres de Contrôle",
    "show-note-labels": "Show Note Labels",
    add: "Ajouter",
    remove: "Enlever",
    "initialize-error": "Une erreur à eu lieu durant le lancement",
    "soundfont-save-notice":
      "Les banques de sons seront enregistrées dans le navigateur.",
    "loading-external-midi": "Loading external MIDI file...",
    initializing: "Initialisation...",
    profile: "Profil",
    "publish-notice":
      "Publier votre morceaux permet aux autres de l'écouter aussi.",
    "published-notice":
      "Votre morceaux est publié. Les autres peuvent donc l'écouter aussi.",
    publish: "Publier",
    unpublish: "Annuler la publication",
    "publish-song": "Publier le morceaux",
    "song-published": "Morceaux publié",
    "song-unpublished": "Publication du morceaux annulée",
    "share-my-song-text":
      "🎶 Je viens de finir un morceaux sur signal! 🎹✨\nÉcoutez ma dernière composition MIDI! 🎧👇\n#midi #signalmidi @signalmidi",
    "publish-rules":
      "Note importante: sur ce site, nous autorisons uniquement la publication de musique que vous avez créée vous-même. Conformément aux lois sur les droits d'auteur, veuillez vous assurer que vous êtes le détenteur des droits d'auteur ou que vous disposez d'une autorisation explicite pour toute musique que vous publiez. La publication non autorisée de la musique d'autrui ou d'œuvres protégées par le droit d'auteur est légalement interdite. Si de telles violations sont détectées, votre message peut être supprimé et des restrictions peuvent être imposées à votre compte. Nous vous encourageons à partager des œuvres créatives et originales et à contribuer à la croissance saine de notre communauté.",
    "soundfont-location": "Emplacement",
    "loading-file": "Chargement du fichier...",
    soundfont: "Banque de son",
    scan: "Scanner",
    midi: "MIDI",
    "no-files": "Pas de fichiers",
    "restore-defaults": "Réstorer les paramètres par défault",
    "user-settings": "Paramètres Utilisateur",
    "delete-account": "Supprimer le compte",
    "delete-account-description":
      "Toutes les chansons et tous les comptes stockés dans le cloud seront supprimés. Une fois supprimées, les données ne peuvent pas être restaurées. Si vous souhaitez vraiment exécuter la suppression, appuyez sur le bouton Supprimer.",
    /* AutoSaveDialog */
    "auto-save-dialog-title": "Restore Auto Saved Song",
    "auto-save-dialog-description":
      "An auto-saved song from your last session was found. Do you want to restore it?",
    "auto-save-dialog-last-save-time": "Last saved at:",
    "auto-save-dialog-restore": "Restore",
    "auto-save-dialog-delete": "Delete",
    /* MIDI Instrument Categories */
    Piano: "Piano",
    "Chromatic Percussion": "Percussion Chromatique",
    Organ: "Orgue",
    Guitar: "Guitare",
    Bass: "Basse",
    Strings: "Cordes",
    Ensemble: "Ensemble",
    Brass: "Cuivre",
    Reed: "Anche",
    Pipe: "Bois",
    "Synth Lead": "Synth Lead",
    "Synth Pad": "Synth Pad",
    "Synth Effects": "Effets Synthétisés",
    Ethnic: "Éthnique",
    Percussive: "Percussions",
    "Sound Effects": "Effets Sonores",
    "Drum Kits": "Drum Kits",
    /* MIDI Instruments */
    "Acoustic Grand Piano": "Grand Piano Acoustique",
    "Bright Acoustic Piano": "Piano Acoustique Lumineux",
    "Electric Grand Piano": "Grand Piano Éléctrique",
    "Honky-tonk Piano": "Piano Honky-tonk",
    "Electric Piano 1": "Piano Éléctrique 1",
    "Electric Piano 2": "Piano Éléctrique 2",
    Harpsichord: "Clavecin",
    Clavinet: "Clavinette",
    Celesta: "Celesta",
    Glockenspiel: "Glockenspiel",
    "Music Box": "Boite à musique",
    Vibraphone: "Vibraphone",
    Marimba: "Marimba",
    Xylophone: "Xylophone",
    "Tubular Bells": "Cloches tubulaires",
    Dulcimer: "Tympanon",
    "Drawbar Organ": "Orgue à barre d'attelage",
    "Percussive Organ": "Orgue Percussif",
    "Rock Organ": "Orgue de Rock",
    "Church Organ": "Orgue d'Église",
    "Reed Organ": "Orgue de barbarie",
    Accordion: "Accordéon",
    Harmonica: "Harmonica",
    "Tango Accordion": "Accordéon Tango",
    "Acoustic Guitar (nylon)": "Guitare Acoustique (nylon)",
    "Acoustic Guitar (steel)": "Guitare Acoustique (steel)",
    "Electric Guitar (jazz)": "Guitare Éléctrique (jazz)",
    "Electric Guitar (clean)": "Guitare Éléctrique (clean)",
    "Electric Guitar (muted)": "Guitare Éléctrique (muted)",
    "Overdriven Guitar": "Overdriven Guitar",
    "Distortion Guitar": "Distortion Guitar",
    "Guitar Harmonics": "Guitar Harmonics",
    "Acoustic Bass": "Basse Acoustique",
    "Electric Bass (finger)": "Basse Éléctrique (finger)",
    "Electric Bass (pick)": "Basse Éléctrique (pick)",
    "Fretless Bass": "Basse sans frettes",
    "Slap Bass 1": "Basse Slap 1",
    "Slap Bass 2": "Basse Slap 2",
    "Synth Bass 1": "Synthétiseur de Basse 1",
    "Synth Bass 2": "Synthétiseur de Basse 2",
    Violin: "Violon",
    Viola: "Alto",
    Cello: "Violoncelle",
    Contrabass: "Contrabasse",
    "Tremolo Strings": "Cordes en Trémolo",
    "Pizzicato Strings": "Cordes en Pizzicato",
    "Orchestral Harp": "Harpe Orchestrale",
    Timpani: "Timbales",
    "String Ensemble 1": "Ensemble de Cordes 1",
    "String Ensemble 2": "Ensemble de Cordes 2",
    "Synth Strings 1": "Synthétiseur de Cordes 1",
    "Synth Strings 2": "Synthétiseur de Cordes 2",
    "Choir Aahs": "Chorale de Aahs",
    "Voice Oohs": "Chorale de Oohs",
    "Synth Choir": "Synthétiseur de Choir",
    "Orchestra Hit": "Coup d'Orchestre",
    Trumpet: "Trompette",
    Trombone: "Trombone",
    Tuba: "Tuba",
    "Muted Trumpet": "Muted Trumpet",
    "French Horn": "Cor",
    "Brass Section": "Séction de Cuivres",
    "Synth Brass 1": "Synthétiseur de Cuivres 1",
    "Synth Brass 2": "Synthétiseur de Cuivres 2",
    "Soprano Sax": "Saxophone Soprano",
    "Alto Sax": "Saxophone Alto",
    "Tenor Sax": "Saxophone Ténor",
    "Baritone Sax": "Saxophone Bariton",
    Oboe: "Hautbois",
    "English Horn": "Cor Anglais",
    Bassoon: "Basson",
    Clarinet: "Clarinette",
    Piccolo: "Piccolo",
    Flute: "Flûte",
    Recorder: "Flûte à bec",
    "Pan Flute": "Flûte de Pan",
    "Blown Bottle": "Souffle sur une Bouteille",
    Shakuhachi: "Shakuhachi",
    Whistle: "Sifflement",
    Ocarina: "Ocarina",
    "Lead 1 (square)": "Synthétiseur 1 (carré)",
    "Lead 2 (sawtooth)": "Synthétiseur 2 (à dents de scie)",
    "Lead 3 (calliope)": "Synthétiseur 3 (calliope)",
    "Lead 4 (chiff)": "Synthétiseur 4 (chiffe)",
    "Lead 5 (charang)": "Synthétiseur 5 (charang)",
    "Lead 6 (voice)": "Synthétiseur 6 (voix)",
    "Lead 7 (fifths)": "Synthétiseur 7 (quintes)",
    "Lead 8 (bass + lead)": "Synthétiseur 8 (basse + synthétiseur)",
    "Pad 1 (new age)": "Pad 1 (nouvelle ère)",
    "Pad 2 (warm)": "Pad 2 (chaud)",
    "Pad 3 (polysynth)": "Pad 3 (polysynthé)",
    "Pad 4 (choir)": "Pad 4 (chorale)",
    "Pad 5 (bowed)": "Pad 5 (incliné)",
    "Pad 6 (metallic)": "Pad 6 (metallique)",
    "Pad 7 (halo)": "Pad 7 (halo)",
    "Pad 8 (sweep)": "Pad 8 (balais)",
    "FX 1 (rain)": "Éffet 1 (pluie)",
    "FX 2 (soundtrack)": "Éffet 2 (bande son)",
    "FX 3 (crystal)": "Éffet 3 (cristal)",
    "FX 4 (atmosphere)": "Éffet 4 (atmosphere)",
    "FX 5 (brightness)": "Éffet 5 (luminosité)",
    "FX 6 (goblins)": "Éffet 6 (goblins)",
    "FX 7 (echoes)": "Éffet 7 (echos)",
    "FX 8 (sci-fi)": "Éffet 8 (science-fiction)",
    Sitar: "Sitar",
    Banjo: "Banjo",
    Shamisen: "Shamisen",
    Koto: "Koto",
    Kalimba: "Kalimba",
    Bagpipe: "Bagpipe",
    Fiddle: "Violon (Fiddle)",
    Shanai: "Shanai",
    "Tinkle Bell": "Grelot",
    Agogo: "Agogo",
    "Steel Drums": "Fût en acier",
    Woodblock: "Woodblock",
    "Taiko Drum": "Taiko",
    "Melodic Tom": "Tom Mélodique",
    "Synth Drum": "Synthétiseur de Batterie",
    "Reverse Cymbal": "Cymbale Inversée",
    "Guitar Fret Noise": "Bruits de frette de guitare",
    "Breath Noise": "Bruit de respiration",
    Seashore: "Vague",
    "Bird Tweet": "Gazouillement",
    "Telephone Ring": "Sonnerie de Téléphone",
    Helicopter: "Hélicoptère",
    Applause: "Applaudissement",
    Gunshot: "Coup de feu",
    /* Drum Kit Instruments */
    "Standard Drum Kit": "Standard Drum Kit",
    "Room Drum Kit": "Room Drum Kit",
    "Power Drum Kit": "Power Drum Kit",
    "Electronic Drum Kit": "Electronic Drum Kit",
    "Analog Drum Kit": "Analog Drum Kit",
    "Jazz Drum Kit": "Jazz Drum Kit",
    "Brush Drum Kit": "Brush Drum Kit",
    "Orchestra Drum Kit": "Orchestra Drum Kit",
    "SFX Drum Kit": "SFX Drum Kit",
    /* */
    velocity: "Velocité",
    "pitch-bend": "Modulateur de Hauteur",
    volume: "Volume",
    panpot: "Panpot",
    expression: "Expression",
    "hold-pedal": "Tenir la Pédal",
    pan: "Pan",
    event: "Évenement",
    duration: "Durée",
    tick: "Tick",
    value: "Valeur",
    key: "Clé",
    scale: "Échelle",
    "show-scale": "Montrer l'Échelle",
    "hide-scale": "Masquer l'Échelle",
    /* Scale */
    "scale-major": "Majeur",
    "scale-minor": "Mineur",
    "scale-harmonic-minor": "Harmonique Mineure",
    "scale-harmonic-major": "Harmonique Majeure",
    "scale-melodic-minor": "Melodique Mineure",
    "scale-ionian": "Ionien",
    "scale-dorian": "Dorien",
    "scale-phrygian": "Phrygien",
    "scale-lydian": "Lydien",
    "scale-mixolydian": "Mixolydien",
    "scale-aeolian": "Aeolien",
    "scale-locrian": "Locrien",
    "scale-major-pentatonic": "Pentatonique Majeure",
    "scale-minor-pentatonic": "Pentatonique Mineure",
    "scale-major-blues": "Blues Majeure",
    "scale-minor-blues": "Blues Mineure",
    "scale-half-whole-diminished": "Demi ton diminué",
    "scale-whole-half-diminished": "Ton complet diminué",
    "scale-whole-tone": "Ton complet",
    /* operation */
    "operation-set": "Mêttre",
    "operation-add": "Ajouter",
    "operation-multiply": "Multiplier",
  },
  ja: {
    "piano-roll": "ピアノロール",
    tempo: "テンポ",
    "time-signature": "拍子",
    "add-time-signature": "拍子を追加",
    "remove-time-signature": "拍子を削除",
    file: "ファイル",
    edit: "編集",
    "new-song": "新規作成",
    "open-song": "開く",
    "save-song": "保存",
    "save-as": "名前を付けて保存",
    "song-created": "楽曲が作成されました",
    "song-saving": "楽曲を保存中...",
    "song-saved": "楽曲が保存されました",
    "download-midi": "MIDIファイルをダウンロード",
    "untitled-song": "無題の楽曲",
    name: "名前",
    rename: "名前の変更",
    track: "トラック",
    "add-track": "トラックを追加",
    "delete-track": "トラックを削除",
    "duplicate-track": "トラックを複製",
    channel: "チャンネル",
    categories: "カテゴリ",
    instruments: "楽器",
    "rhythm-track": "リズムトラック",
    "conductor-track": "コンダクタートラック",
    "track-name": "トラック名",
    "midi-routing": "ルーティング",
    "midi-routing-selected-track": "アクティブトラック",
    "midi-routing-selected-track-description":
      "すべての入力を選択中のトラックに送ります",
    "midi-routing-channel": "マルチトラック",
    "midi-routing-channel-description":
      "MIDIチャンネルに対応するトラックに送り、複数トラックを同時に録音できます",
    cancel: "キャンセル",
    insert: "挿入",
    ok: "OK",
    reset: "リセット",
    triplet: "三連符",
    dotted: "付点",
    "confirm-new": "編集中の楽曲が破棄されます。本当に新規作成しますか？",
    "confirm-open": "編集中の楽曲が破棄されます。本当に開きますか？",
    "confirm-close": "編集中の楽曲が破棄されます。本当にページを閉じますか？",
    "auto-scroll": "自動でスクロール",
    help: "ヘルプ",
    close: "閉じる",
    "keyboard-shortcut": "キーボードショートカット",
    "play-pause": "再生・一時停止",
    rewind: "巻戻し",
    "fast-forward": "早送り",
    "forward-rewind": "早送り・巻き戻し",
    "start-stop-recording": "Start/Stop Recording",
    "next-previous-track": "次のトラック・前のトラック",
    "solo-mute-ghost": "ソロ・ミュート・ゴーストトラックの切り替え",
    stop: "停止",
    record: "録音",
    "pencil-tool": "鉛筆ツール",
    "selection-tool": "選択ツール",
    "control-pencil-tool": "フリー",
    "control-single-tool": "単点",
    "control-line-tool": "直線",
    "control-curve-tool": "曲線",
    "curve-ease-in": "加速曲線",
    "curve-ease-out": "減速曲線",
    "copy-selection": "選択範囲をコピー",
    "cut-selection": "選択範囲を切り取り",
    "paste-selection": "コピーした選択範囲を現在位置に貼り付け",
    "select-all": "すべて選択",
    "select-next": "次を選択",
    "select-previous": "前を選択",
    "delete-selection": "選択範囲を削除",
    "move-selection": "選択範囲を移動",
    undo: "元に戻す",
    redo: "やり直し",
    cut: "切り取り",
    copy: "コピー",
    copied: "コピーしました",
    paste: "ペースト",
    duplicate: "複製",
    delete: "削除",
    "song-deleted": "曲を削除しました",
    "song-delete-failed": "曲の削除に失敗しました",
    "select-note": "ノートを選択",
    "scroll-horizontally": "左右にスクロール",
    "scroll-vertically": "上下にスクロール",
    settings: "設定",
    language: "言語",
    theme: "テーマ",
    "midi-settings": "MIDI設定",
    inputs: "入力",
    outputs: "出力",
    "no-inputs": "入力デバイスが見つかりません",
    "one-octave-up": "+1オクターブ",
    "one-octave-down": "-1オクターブ",
    arrange: "アレンジ",
    "arrangement-view": "アレンジビュー",
    "open-help": "ヘルプを開く",
    "event-list": "イベントリスト",
    "open-chat": "チャットを開く",
    property: "プロパティ",
    quantize: "クオンタイズ",
    "snap-to-grid": "グリッドにスナップ",
    "export-audio": "オーディオ書き出し",
    export: "書き出し",
    "exporting-audio": "オーディオを書き出し中...",
    "file-type": "ファイル形式",
    "export-error-too-short": "曲が短すぎます",
    "set-loop-start": "ループ開始位置を設定",
    "set-loop-end": "ループ終了位置を設定",
    "switch-tab": "タブを切り替え",
    transpose: "トランスポーズ",
    yes: "はい",
    no: "いいえ",
    "please-sign-up": "サインアップしてクラウドセーブを利用",
    "save-changes": "曲への変更を保存しますか?",
    "sign-in": "サインイン",
    "sign-out": "サインアウト",
    "success-sign-in": "サインインに成功しました",
    files: "ファイル",
    "created-date": "作成日時",
    "modified-date": "更新日時",
    "cloud-beta-warning":
      "クラウド機能は開発中のベータ版のため、大事な楽曲はこまめにダウンロードをお願いします。",
    "cloud-description":
      "サインインすることで楽曲をクラウドに保存し、いつでもどこからでも作曲を再開することができます。",
    "import-midi": "MIDI をインポート",
    "export-midi": "MIDI をエクスポート",
    general: "一般",
    appearance: "表示",
    "change-track-color": "トラックの色を変更",
    "control-settings": "コントロール設定",
    "show-note-labels": "ノートラベルを表示",
    add: "追加",
    remove: "削除",
    "initialize-error": "起動時の処理でエラーが発生しました",
    "soundfont-save-notice": "サウンドフォントはブラウザー内に保存されます",
    "loading-external-midi": "外部のMIDIファイルを読み込み中...",
    initializing: "起動中...",
    profile: "プロフィール",
    "publish-notice":
      "楽曲を公開すると他のユーザーがこの曲を聴くことができるようになります。",
    "published-notice": "この曲は公開されています。",
    publish: "公開",
    unpublish: "非公開",
    "publish-song": "曲を公開",
    "song-published": "曲を公開しました",
    "song-unpublished": "曲を非公開にしました",
    "share-my-song-text":
      "🎶 signalで新しいトラックを作成しました！🎹✨\nMIDIを聴いてください！🎧👇\n#midi #signalmidi @signalmidi",
    "publish-rules":
      "重要なお知らせ：当サイトでは、あなた自身が制作した楽曲のみの投稿を許可しています。著作権法に基づき、あなたが著作権者である、または明示的な許可を得た楽曲のみを投稿してください。他者の楽曲や、著作権で保護されている作品を無許可で公開することは、法的に禁止されています。このような違反が発見された場合、投稿は削除され、アカウントに対して制限が加えられる可能性があります。クリエイティブでオリジナルな作品を共有し、コミュニティの健全な成長にご協力ください。",
    "soundfont-location": "ロケーション",
    "loading-file": "ファイルをロード中...",
    soundfont: "SoundFont",
    scan: "スキャン",
    midi: "MIDI",
    "no-files": "ファイルがありません",
    "restore-defaults": "デフォルトに戻す",
    "user-settings": "ユーザー設定",
    "delete-account": "アカウント削除",
    "delete-account-description":
      "クラウドに保存されたすべての楽曲とアカウントが削除されます。一度削除したデータは復元できません。本当に削除を実行しますか？",
    /* AutoSaveDialog */
    "auto-save-dialog-title": "自動保存された曲を復元",
    "auto-save-dialog-description":
      "前回のセッションから自動保存された曲が見つかりました。復元しますか？",
    "auto-save-dialog-last-save-time": "最後の保存時間:",
    "auto-save-dialog-restore": "復元",
    "auto-save-dialog-delete": "削除",
    /* MIDI Instrument Categories */
    Piano: "ピアノ",
    "Chromatic Percussion": "クロマチック",
    Organ: "オルガン",
    Guitar: "ギター",
    Bass: "ベース",
    Strings: "ストリングス",
    Ensemble: "アンサンブル",
    Brass: "ブラス",
    Reed: "リード",
    Pipe: "笛",
    "Synth Lead": "シンセリード",
    "Synth Pad": "シンセパッド",
    "Synth Effects": "シンセエフェクト",
    Ethnic: "民族楽器",
    Percussive: "打楽器",
    "Sound Effects": "効果音",
    "Drum Kits": "ドラムキット",
    /* MIDI Instruments */
    "Acoustic Grand Piano": "アコースティックピアノ",
    "Bright Acoustic Piano": "ブライトピアノ",
    "Electric Grand Piano": "エレクトリック・グランドピアノ",
    "Honky-tonk Piano": "ホンキートンクピアノ",
    "Electric Piano 1": "エレクトリックピアノ",
    "Electric Piano 2": "FMエレクトリックピアノ",
    Harpsichord: "ハープシコード",
    Clavinet: "クラビネット",
    Celesta: "チェレスタ",
    Glockenspiel: "グロッケンシュピール",
    "Music Box": "オルゴール",
    Vibraphone: "ヴィブラフォン",
    Marimba: "マリンバ",
    Xylophone: "木琴",
    "Tubular Bells": "チューブラーベル",
    Dulcimer: "ダルシマー",
    "Drawbar Organ": "ドローバーオルガン",
    "Percussive Organ": "パーカッシブオルガン",
    "Rock Organ": "ロックオルガン",
    "Church Organ": "チャーチオルガン",
    "Reed Organ": "リードオルガン",
    Accordion: "アコーディオン",
    Harmonica: "ハーモニカ",
    "Tango Accordion": "タンゴアコーディオン",
    "Acoustic Guitar (nylon)": "アコースティックギター（ナイロン弦）",
    "Acoustic Guitar (steel)": "アコースティックギター（スチール弦）",
    "Electric Guitar (jazz)": "ジャズギター",
    "Electric Guitar (clean)": "クリーンギター",
    "Electric Guitar (muted)": "ミュートギター",
    "Overdriven Guitar": "オーバードライブギター",
    "Distortion Guitar": "ディストーションギター",
    "Guitar Harmonics": "ギターハーモニクス",
    "Acoustic Bass": "アコースティックベース",
    "Electric Bass (finger)": "フィンガーベース",
    "Electric Bass (pick)": "ピックベース",
    "Fretless Bass": "フレットレスベース",
    "Slap Bass 1": "スラップベース 1",
    "Slap Bass 2": "スラップベース 2",
    "Synth Bass 1": "シンセベース 1",
    "Synth Bass 2": "シンセベース 2",
    Violin: "ヴァイオリン",
    Viola: "ヴィオラ",
    Cello: "チェロ",
    Contrabass: "コントラバス",
    "Tremolo Strings": "トレモロストリングス",
    "Pizzicato Strings": "ピッツィカートストリングス",
    "Orchestral Harp": "ハープ",
    Timpani: "ティンパニ",
    "String Ensemble 1": "ストリングアンサンブル",
    "String Ensemble 2": "スローストリングアンサンブル",
    "Synth Strings 1": "シンセストリングス",
    "Synth Strings 2": "シンセストリングス2",
    "Choir Aahs": "声「アー」",
    "Voice Oohs": "声「ドゥー」",
    "Synth Choir": "シンセヴォイス",
    "Orchestra Hit": "オーケストラヒット",
    Trumpet: "トランペット",
    Trombone: "トロンボーン",
    Tuba: "チューバ",
    "Muted Trumpet": "ミュートトランペット",
    "French Horn": "フレンチ・ホルン",
    "Brass Section": "ブラスセクション",
    "Synth Brass 1": "シンセブラス 1",
    "Synth Brass 2": "シンセブラス 2",
    "Soprano Sax": "ソプラノサックス",
    "Alto Sax": "アルトサックス",
    "Tenor Sax": "テナーサックス",
    "Baritone Sax": "バリトンサックス",
    Oboe: "オーボエ",
    "English Horn": "イングリッシュホルン",
    Bassoon: "ファゴット",
    Clarinet: "クラリネット",
    Piccolo: "ピッコロ",
    Flute: "フルート",
    Recorder: "リコーダー",
    "Pan Flute": "パンフルート",
    "Blown Bottle": "ブロウンボトル",
    Shakuhachi: "尺八",
    Whistle: "口笛",
    Ocarina: "オカリナ",
    "Lead 1 (square)": "正方波",
    "Lead 2 (sawtooth)": "ノコギリ波",
    "Lead 3 (calliope)": "カリオペリード",
    "Lead 4 (chiff)": "チフリード",
    "Lead 5 (charang)": "チャランゴリード",
    "Lead 6 (voice)": "ボイスリード",
    "Lead 7 (fifths)": "フィフスズリード",
    "Lead 8 (bass + lead)": "ベース + リード",
    "Pad 1 (new age)": "ファンタジア",
    "Pad 2 (warm)": "ウォーム",
    "Pad 3 (polysynth)": "ポリシンセ",
    "Pad 4 (choir)": "クワイア",
    "Pad 5 (bowed)": "ボウ",
    "Pad 6 (metallic)": "メタリック",
    "Pad 7 (halo)": "ハロー",
    "Pad 8 (sweep)": "スウィープ",
    "FX 1 (rain)": "雨",
    "FX 2 (soundtrack)": "サウンドトラック",
    "FX 3 (crystal)": "クリスタル",
    "FX 4 (atmosphere)": "アトモスフィア",
    "FX 5 (brightness)": "ブライトネス",
    "FX 6 (goblins)": "ゴブリン",
    "FX 7 (echoes)": "エコー",
    "FX 8 (sci-fi)": "サイファイ",
    Sitar: "シタール",
    Banjo: "バンジョー",
    Shamisen: "三味線",
    Koto: "琴",
    Kalimba: "カリンバ",
    Bagpipe: "バグパイプ",
    Fiddle: "フィドル",
    Shanai: "シャハナーイ",
    "Tinkle Bell": "ティンクルベル",
    Agogo: "アゴゴ",
    "Steel Drums": "スチールドラム",
    Woodblock: "ウッドブロック",
    "Taiko Drum": "太鼓",
    "Melodic Tom": "メロディックタム",
    "Synth Drum": "シンセドラム",
    "Reverse Cymbal": "リバースシンバル",
    "Guitar Fret Noise": "ギターフレットノイズ",
    "Breath Noise": "ブレスノイズ",
    Seashore: "海岸",
    "Bird Tweet": "鳥のさえずり",
    "Telephone Ring": "電話のベル",
    Helicopter: "ヘリコプター",
    Applause: "拍手",
    Gunshot: "銃声",
    /* Drum Kit Instruments */
    "Standard Drum Kit": "Standard Drum Kit",
    "Room Drum Kit": "Room Drum Kit",
    "Power Drum Kit": "Power Drum Kit",
    "Electronic Drum Kit": "Electronic Drum Kit",
    "Analog Drum Kit": "Analog Drum Kit",
    "Jazz Drum Kit": "Jazz Drum Kit",
    "Brush Drum Kit": "Brush Drum Kit",
    "Orchestra Drum Kit": "Orchestra Drum Kit",
    "SFX Drum Kit": "SFX Drum Kit",
    /* */
    velocity: "ベロシティ",
    "pitch-bend": "ピッチベンド",
    volume: "ボリューム",
    panpot: "パン",
    expression: "エクスプレッション",
    "hold-pedal": "ホールドペダル",
    pan: "パン",
    event: "イベント",
    duration: "Duration",
    tick: "Tick",
    value: "Value",
    key: "キー",
    scale: "スケール",
    "show-scale": "スケールを表示",
    "hide-scale": "スケールを隠す",
    /* Scale */
    "scale-major": "メジャー",
    "scale-minor": "マイナー",
    "scale-harmonic-minor": "ハーモニックマイナー",
    "scale-harmonic-major": "ハーモニックメジャー",
    "scale-melodic-minor": "メロディックマイナー",
    "scale-ionian": "イオニアン",
    "scale-dorian": "ドリアン",
    "scale-phrygian": "フリジアン",
    "scale-lydian": "リディアン",
    "scale-mixolydian": "ミクソリディアン",
    "scale-aeolian": "エオリアン",
    "scale-locrian": "ロクリアン",
    "scale-major-pentatonic": "メジャーペンタトニック",
    "scale-minor-pentatonic": "マイナーペンタトニック",
    "scale-major-blues": "メジャーブルース",
    "scale-minor-blues": "マイナーブルース",
    "scale-half-whole-diminished": "ハーフホールディミニッシュ",
    "scale-whole-half-diminished": "ホールハーフディミニッシュ",
    "scale-whole-tone": "ホールトーン",
    /* operation */
    "operation-set": "変更",
    "operation-add": "加算",
    "operation-multiply": "乗算",
  },
  "zh-Hans": {
    "piano-roll": "钢琴卷",
    tempo: "速度",
    "time-signature": "拍号",
    "add-time-signature": "添加拍号",
    "remove-time-signature": "删除拍号",
    file: "文件",
    edit: "Edit",
    "new-song": "新建",
    "open-song": "打开",
    "save-song": "保存",
    "save-as": "另存为",
    "song-created": "曲目已创建",
    "song-saving": "Saving song...",
    "song-saved": "曲目已保存",
    "download-midi": "Download MIDI File",
    "untitled-song": "未命名",
    name: "名称",
    rename: "重命名",
    track: "音轨",
    "add-track": "添加音轨",
    "delete-track": "删除音轨",
    "duplicate-track": "复制音轨",
    channel: "频道",
    categories: "类别",
    instruments: "乐器",
    "rhythm-track": "节奏轨",
    "conductor-track": "指挥轨",
    "track-name": "音轨名",
    "midi-routing": "路由",
    "midi-routing-selected-track": "活跃轨道",
    "midi-routing-selected-track-description":
      "将所有MIDI输入发送到当前选中的轨道",
    "midi-routing-channel": "多轨道",
    "midi-routing-channel-description":
      "按MIDI通道将输入路由到对应轨道，可同时录制多个轨道",
    cancel: "取消",
    insert: "插入",
    ok: "确定",
    reset: "Reset",
    triplet: "三连音",
    dotted: "附点",
    "confirm-new": "正在编辑曲目，您确定要新建一个吗？",
    "confirm-open": "正在编辑曲目，您确定要打开另一个吗？",
    "confirm-close": "正在编辑曲目，您确定要关闭吗？",
    "auto-scroll": "自动滚动",
    help: "帮助",
    close: "关闭",
    "keyboard-shortcut": "快捷键",
    "play-pause": "播放/暂停",
    rewind: "快退",
    "fast-forward": "快进",
    "forward-rewind": "快进/快退",
    "start-stop-recording": "Start/Stop Recording",
    "next-previous-track": "下一音轨/上一音轨",
    "solo-mute-ghost": "独奏/静音/幽灵音",
    stop: "停止",
    record: "录音",
    "pencil-tool": "铅笔工具",
    "selection-tool": "选择工具",
    "control-pencil-tool": "自由",
    "control-single-tool": "单点",
    "control-line-tool": "直线",
    "control-curve-tool": "曲线",
    "curve-ease-in": "加速曲线",
    "curve-ease-out": "减速曲线",
    "copy-selection": "拷贝选择的内容",
    "cut-selection": "剪切选择的内容",
    "paste-selection": "粘贴选择的内容",
    "select-all": "全选",
    "select-next": "Select Next",
    "select-previous": "Select Previous",
    "delete-selection": "删除选择的内容",
    "move-selection": "移动选择的内容",
    undo: "撤消",
    redo: "恢复",
    cut: "剪切",
    copy: "拷贝",
    copied: "Copied",
    paste: "粘贴",
    duplicate: "复制",
    delete: "删除",
    "song-deleted": "Song deleted",
    "song-delete-failed": "Song delete failed",
    "select-note": "选择音符",
    "scroll-horizontally": "左右滚动",
    "scroll-vertically": "上下滚动",
    settings: "设置",
    language: "语言",
    theme: "Theme",
    "midi-settings": "MIDI设置",
    inputs: "输入",
    outputs: "输出",
    "no-inputs": "No input devices found",
    "one-octave-up": "+1 个八度",
    "one-octave-down": "-1 个八度",
    arrange: "编排",
    "arrangement-view": "编排视图",
    "open-help": "打开帮助",
    "event-list": "事件列表",
    "open-chat": "打开聊天框",
    property: "属性",
    quantize: "量化",
    "snap-to-grid": "对齐网格",
    "export-audio": "导出音频",
    export: "导出",
    "exporting-audio": "正在导出音频...",
    "file-type": "文件格式",
    "export-error-too-short": "这首曲目长度太短了",
    "set-loop-start": "设置循环开始位置",
    "set-loop-end": "设置循环结束位置",
    "switch-tab": "切换标签",
    transpose: "移调",
    yes: "是",
    no: "否",
    "please-sign-up": "注册来使用云存档",
    "save-changes": "是否要保存对曲目的更改？",
    "sign-in": "登录",
    "sign-out": "Sign Out",
    "success-sign-in": "登录成功",
    files: "文件",
    "created-date": "创建日期",
    "modified-date": "修改日期",
    "cloud-beta-warning":
      "由于云功能处于开发阶段，请及时下载保存您创作的重要曲目。",
    "cloud-description":
      "通过登录，您可以将您的曲目保存到云端并随时随地恢复作曲。",
    "import-midi": "导入 MIDI",
    "export-midi": "导出 MIDI",
    general: "General",
    appearance: "Appearance",
    "change-track-color": "Change Track Color",
    "control-settings": "Control Settings",
    "show-note-labels": "Show Note Labels",
    add: "Add",
    remove: "Remove",
    "initialize-error": "Error occured in launch process",
    "soundfont-save-notice": "SoundFont will be saved in the browser.",
    "loading-external-midi": "Loading external MIDI file...",
    initializing: "Initializing...",
    profile: "Profile",
    "publish-notice":
      "Publishing your song makes it available for other users to listen to.",
    "published-notice":
      "Your song is published and available for other users to listen to.",
    publish: "Publish",
    unpublish: "Unpublish",
    "publish-song": "Publish Song",
    "song-published": "Song published",
    "song-unpublished": "Song unpublished",
    "share-my-song-text":
      "🎶 Just created a new track on signal! 🎹✨\nListen to my latest MIDI composition! 🎧👇\n#midi #signalmidi @signalmidi",
    "publish-rules":
      "重要通知：本网站只允许发布您自己创作的音乐作品。根据著作权法，请确保您是音乐作品的著作权持有人，或已获得明确许可。未经授权公开他人音乐或受著作权保护的作品是法律所禁止的。如果发现此类违规行为，您的帖子可能会被删除，且您的账户可能会受到限制。我们鼓励您分享创意和原创作品，共同促进我们社区的健康成长。",
    "soundfont-location": "Location",
    "loading-file": "Loading file...",
    soundfont: "SoundFont",
    scan: "Scan",
    midi: "MIDI",
    "no-files": "No files",
    "restore-defaults": "Restore Defaults",
    "user-settings": "User Settings",
    "delete-account": "Delete Account",
    "delete-account-description":
      "All songs and accounts stored in the cloud will be deleted. Once deleted, the data cannot be restored. If you really want to execute the deletion, press the Delete button.",
    /* AutoSaveDialog */
    "auto-save-dialog-title": "Restore Auto Saved Song",
    "auto-save-dialog-description":
      "An auto-saved song from your last session was found. Do you want to restore it?",
    "auto-save-dialog-last-save-time": "Last saved at:",
    "auto-save-dialog-restore": "Restore",
    "auto-save-dialog-delete": "Delete",
    /* MIDI Instrument Categories */
    Piano: "钢琴",
    "Chromatic Percussion": "半音打击乐",
    Organ: "风琴",
    Guitar: "吉他",
    Bass: "贝司",
    Strings: "弦乐独奏",
    Ensemble: "合唱合奏",
    Brass: "铜管乐器",
    Reed: "哨片乐器",
    Pipe: "吹管乐器",
    "Synth Lead": "合成主音",
    "Synth Pad": "合成柔音",
    "Synth Effects": "合成特效",
    Ethnic: "民族乐器",
    Percussive: "打击乐",
    "Sound Effects": "声音特效",
    "Drum Kits": "Drum Kits",
    /* MIDI Instruments */
    "Acoustic Grand Piano": "大钢琴",
    "Bright Acoustic Piano": "立式钢琴",
    "Electric Grand Piano": "电钢琴",
    "Honky-tonk Piano": "酒吧钢琴",
    "Electric Piano 1": "电钢琴1",
    "Electric Piano 2": "电钢琴2",
    Harpsichord: "拨弦古钢琴",
    Clavinet: "击弦古钢琴",
    Celesta: "钢片琴",
    Glockenspiel: "钟琴",
    "Music Box": "八音盒",
    Vibraphone: "电颤琴",
    Marimba: "马林巴",
    Xylophone: "木琴",
    "Tubular Bells": "管钟",
    Dulcimer: "扬琴",
    "Drawbar Organ": "击杆风琴",
    "Percussive Organ": "打击型风琴",
    "Rock Organ": "摇滚风琴",
    "Church Organ": "管风琴",
    "Reed Organ": "簧风琴",
    Accordion: "手风琴",
    Harmonica: "口琴",
    "Tango Accordion": "探戈手风琴",
    "Acoustic Guitar (nylon)": "尼龙弦吉他",
    "Acoustic Guitar (steel)": "钢弦吉他",
    "Electric Guitar (jazz)": "爵士乐电吉他",
    "Electric Guitar (clean)": "清音电吉他",
    "Electric Guitar (muted)": "弱音电吉他",
    "Overdriven Guitar": "驱动音效吉他",
    "Distortion Guitar": "失真音效吉他",
    "Guitar Harmonics": "吉他泛音",
    "Acoustic Bass": "原声贝司",
    "Electric Bass (finger)": "指拨电贝司",
    "Electric Bass (pick)": "拨片拨电贝司",
    "Fretless Bass": "无品贝司",
    "Slap Bass 1": "击弦贝司1",
    "Slap Bass 2": "击弦贝司2",
    "Synth Bass 1": "合成贝司1",
    "Synth Bass 2": "合成贝司2",
    Violin: "小提琴",
    Viola: "中提琴",
    Cello: "大提琴",
    Contrabass: "低音提琴",
    "Tremolo Strings": "弦乐震音",
    "Pizzicato Strings": "弦乐拨奏",
    "Orchestral Harp": "竖琴",
    Timpani: "定音鼓",
    "String Ensemble 1": "弦乐合奏1",
    "String Ensemble 2": "弦乐合奏2",
    "Synth Strings 1": "合成弦乐1",
    "Synth Strings 2": "合成弦乐2",
    "Choir Aahs": "合唱“啊”音",
    "Voice Oohs": "人声“嘟”音",
    "Synth Choir": "合成人声",
    "Orchestra Hit": "乐队打击乐",
    Trumpet: "小号",
    Trombone: "长号",
    Tuba: "大号",
    "Muted Trumpet": "弱音小号",
    "French Horn": "圆号",
    "Brass Section": "铜管组",
    "Synth Brass 1": "合成铜管1",
    "Synth Brass 2": "合成铜管2",
    "Soprano Sax": "高音萨克斯",
    "Alto Sax": "中音萨克斯",
    "Tenor Sax": "次中音萨克斯",
    "Baritone Sax": "上低音萨克斯",
    Oboe: "双簧管",
    "English Horn": "英国管",
    Bassoon: "大管",
    Clarinet: "单簧管",
    Piccolo: "短笛",
    Flute: "长笛",
    Recorder: "竖笛",
    "Pan Flute": "排笛",
    "Blown Bottle": "吹瓶口",
    Shakuhachi: "尺八",
    Whistle: "哨",
    Ocarina: "奥卡雷那",
    "Lead 1 (square)": "合成主音1（方波）",
    "Lead 2 (sawtooth)": "合成主音2（锯齿波）",
    "Lead 3 (calliope)": "合成主音3（汽笛风琴）",
    "Lead 4 (chiff)": "合成主音4 （吹管）",
    "Lead 5 (charang)": "合成主音5（吉他）",
    "Lead 6 (voice)": "合成主音6（人声）",
    "Lead 7 (fifths)": "合成主音7（五度）",
    "Lead 8 (bass + lead)": "合成主音8（贝斯加主音）",
    "Pad 1 (new age)": "合成柔音1（新时代）",
    "Pad 2 (warm)": "合成柔音（暖音）",
    "Pad 3 (polysynth)": "合成柔音3（复合成）",
    "Pad 4 (choir)": "合成柔音4（合唱）",
    "Pad 5 (bowed)": "合成柔音5（弓弦）",
    "Pad 6 (metallic)": "合成柔音6（金属）",
    "Pad 7 (halo)": "合成柔音7（光晕）",
    "Pad 8 (sweep)": "合成柔音8（扫弦）",
    "FX 1 (rain)": "合成特效1（雨）",
    "FX 2 (soundtrack)": "合成特效2（音轨）",
    "FX 3 (crystal)": "合成特效3（水晶）",
    "FX 4 (atmosphere)": "合成特效4（大气）",
    "FX 5 (brightness)": "合成特效5（轻柔）",
    "FX 6 (goblins)": "合成特效6（小妖）",
    "FX 7 (echoes)": "合成特效7（回声）",
    "FX 8 (sci-fi)": "合成特效8（科幻）",
    Sitar: "锡塔尔",
    Banjo: "班卓",
    Shamisen: "三味线",
    Koto: "筝",
    Kalimba: "卡林巴",
    Bagpipe: "风笛",
    Fiddle: "古提琴",
    Shanai: "唢呐",
    "Tinkle Bell": "铃铛",
    Agogo: "拉丁打铃",
    "Steel Drums": "钢鼓",
    Woodblock: "木块",
    "Taiko Drum": "太鼓",
    "Melodic Tom": "嗵鼓",
    "Synth Drum": "合成鼓",
    "Reverse Cymbal": "铜钹",
    "Guitar Fret Noise": "磨弦声",
    "Breath Noise": "呼吸声",
    Seashore: "海浪声",
    "Bird Tweet": "鸟鸣声",
    "Telephone Ring": "电话声",
    Helicopter: "直升机声",
    Applause: "鼓掌声",
    Gunshot: "枪声",
    /* Drum Kit Instruments */
    "Standard Drum Kit": "Standard Drum Kit",
    "Room Drum Kit": "Room Drum Kit",
    "Power Drum Kit": "Power Drum Kit",
    "Electronic Drum Kit": "Electronic Drum Kit",
    "Analog Drum Kit": "Analog Drum Kit",
    "Jazz Drum Kit": "Jazz Drum Kit",
    "Brush Drum Kit": "Brush Drum Kit",
    "Orchestra Drum Kit": "Orchestra Drum Kit",
    "SFX Drum Kit": "SFX Drum Kit",
    /* */
    velocity: "力度控制",
    "pitch-bend": "弯音控制",
    volume: "音量控制",
    panpot: "声像控制",
    expression: "情绪控制",
    "hold-pedal": "延音踏板",
    pan: "声像",
    event: "事件",
    duration: "时长",
    tick: "起始",
    value: "值",
    key: "Key",
    scale: "Scale",
    "show-scale": "Show Scale",
    "hide-scale": "Hide Scale",
    /* Scale */
    "scale-major": "Major",
    "scale-minor": "Minor",
    "scale-harmonic-minor": "Harmonic Minor",
    "scale-harmonic-major": "Harmonic Major",
    "scale-melodic-minor": "Melodic Minor",
    "scale-ionian": "Ionian",
    "scale-dorian": "Dorian",
    "scale-phrygian": "Phrygian",
    "scale-lydian": "Lydian",
    "scale-mixolydian": "Mixolydian",
    "scale-aeolian": "Aeolian",
    "scale-locrian": "Locrian",
    "scale-major-pentatonic": "Major Pentatonic",
    "scale-minor-pentatonic": "Minor Pentatonic",
    "scale-major-blues": "Major Blues",
    "scale-minor-blues": "Minor Blues",
    "scale-half-whole-diminished": "Half-whole Diminished",
    "scale-whole-half-diminished": "Whole-half Diminished",
    "scale-whole-tone": "Whole Tone",
    /* operation */
    "operation-set": "Set",
    "operation-add": "Add",
    "operation-multiply": "Multiply",
  },
  "zh-Hant": {
    "piano-roll": "鋼琴卷軸",
    tempo: "速度",
    "time-signature": "拍號",
    "add-time-signature": "新增拍號",
    "remove-time-signature": "刪除拍號",
    file: "檔案",
    edit: "Edit",
    "new-song": "新增",
    "open-song": "開啟",
    "save-song": "儲存",
    "save-as": "另存為",
    "song-created": "曲目已建立",
    "song-saving": "Saving song...",
    "song-saved": "曲目已儲存",
    "download-midi": "Download MIDI File",
    "untitled-song": "未命名",
    name: "名稱",
    rename: "重新命名",
    track: "音軌",
    "add-track": "新增音軌",
    "delete-track": "刪除音軌",
    "duplicate-track": "複製音軌",
    channel: "頻道",
    categories: "類別",
    instruments: "樂器",
    "rhythm-track": "節奏軌",
    "conductor-track": "指揮軌",
    "track-name": "音軌名稱",
    "midi-routing": "路由",
    "midi-routing-selected-track": "活躍音軌",
    "midi-routing-selected-track-description":
      "將所有MIDI輸入發送到當前選中的音軌",
    "midi-routing-channel": "多音軌",
    "midi-routing-channel-description":
      "按MIDI通道將輸入路由到對應音軌，可同時錄製多個音軌",
    cancel: "取消",
    insert: "插入",
    ok: "確定",
    reset: "重設",
    triplet: "三連音",
    dotted: "附點",
    "confirm-new": "正在編輯曲目，您確定要新增嗎？",
    "confirm-open": "正在編輯曲目，您確定要開啟嗎？",
    "confirm-close": "正在編輯曲目，您確定要關閉嗎？",
    "auto-scroll": "自動滾動",
    help: "說明",
    close: "關閉",
    "keyboard-shortcut": "快速鍵",
    "play-pause": "播放/暫停",
    rewind: "快退",
    "fast-forward": "快進",
    "forward-rewind": "快進/快退",
    "start-stop-recording": "Start/Stop Recording",
    "next-previous-track": "下一音軌/上一音軌",
    "solo-mute-ghost": "獨奏/靜音/幽靈音",
    stop: "停止",
    record: "錄音",
    "pencil-tool": "鉛筆工具",
    "selection-tool": "選擇工具",
    "control-pencil-tool": "自由",
    "control-single-tool": "單點",
    "control-line-tool": "直線",
    "control-curve-tool": "曲線",
    "curve-ease-in": "加速曲線",
    "curve-ease-out": "減速曲線",
    "copy-selection": "複製選擇的內容",
    "cut-selection": "剪下選擇的內容",
    "paste-selection": "貼上選擇的內容",
    "select-all": "全選",
    "select-next": "Select Next",
    "select-previous": "Select Previous",
    "delete-selection": "刪除選擇的內容",
    "move-selection": "移動選擇的內容",
    undo: "復原",
    redo: "重做",
    cut: "剪下",
    copy: "複製",
    copied: "Copied",
    paste: "貼上",
    duplicate: "複製",
    delete: "刪除",
    "song-deleted": "曲目已刪除",
    "song-delete-failed": "曲目刪除失敗",
    "select-note": "選擇音符",
    "scroll-horizontally": "左右滾動",
    "scroll-vertically": "上下滾動",
    settings: "設定",
    language: "語言",
    theme: "Theme",
    "midi-settings": "MIDI設定",
    inputs: "輸入",
    outputs: "輸出",
    "no-inputs": "無連接的裝置",
    "one-octave-up": "+1 個八度",
    "one-octave-down": "-1 個八度",
    arrange: "編排",
    "arrangement-view": "編排視圖",
    "open-help": "打開說明",
    "event-list": "事件列表",
    "open-chat": "打開聊天視窗",
    property: "屬性",
    quantize: "量化",
    "snap-to-grid": "對齊網格",
    "export-audio": "匯出音檔",
    export: "匯出",
    "exporting-audio": "正在匯出音檔...",
    "file-type": "文件格式",
    "export-error-too-short": "曲目長度太短了",
    "set-loop-start": "設定循環開始位置",
    "set-loop-end": "設定循環結束位置",
    "switch-tab": "切換標籤",
    transpose: "移調",
    yes: "是",
    no: "否",
    "please-sign-up": "註冊後可使用雲端儲存",
    "save-changes": "是否要保存對曲目的修改？",
    "sign-in": "登入",
    "sign-out": "登出",
    "success-sign-in": "登入成功",
    files: "文件",
    "created-date": "建立日期",
    "modified-date": "修改日期",
    "cloud-beta-warning":
      "因雲端儲存功能仍處於Beta階段，請時時下載並儲存您的重要曲目。",
    "cloud-description":
      "通過登入，您可以將您的曲目儲存到雲端並隨時隨地打開繼續編輯。",
    "import-midi": "匯入 MIDI",
    "export-midi": "匯出 MIDI",
    general: "一般",
    appearance: "Appearance",
    "change-track-color": "更改音軌顏色",
    "control-settings": "設定控制功能",
    "show-note-labels": "Show Note Labels",
    add: "新增",
    remove: "移除",
    "initialize-error": "啟動時初始化發生錯誤",
    "soundfont-save-notice": "SoundFont會儲存在瀏覽器中",
    "loading-external-midi": "正在讀取MIDI檔...",
    initializing: "啟動中...",
    profile: "個人資訊",
    "publish-notice": "一旦公開樂曲，其他的使用者也將可以聆聽您的曲目。",
    "published-notice": "您的曲目已公開，其他人也可聆聽您的曲目。",
    publish: "公開",
    unpublish: "非公開",
    "publish-song": "將曲目公開",
    "song-published": "曲目已設為公開",
    "song-unpublished": "曲目已設為非公開",
    "share-my-song-text":
      "🎶 我用signal做了一首曲子囉！🎹✨\n來聽聽看我的MIDI作品吧！🎧👇\n#midi #signalmidi @signalmidi",
    "publish-rules":
      "重要通知：本網站只允許發佈您自己創作的音樂作品。根據著作權法，請確保您是音樂作品的著作權持有者，或已獲得明確許可。未經授權公開他人音樂或受著作權保護的作品是法律所禁止的。如果發現此類違規行為，您的貼文可能會被刪除，且您的帳號可能會受到限制。我們鼓勵您分享創意和原創作品，共同促進我們社群的健康成長。",
    "soundfont-location": "Location",
    "loading-file": "Loading file...",
    soundfont: "SoundFont",
    scan: "Scan",
    midi: "MIDI",
    "no-files": "No files",
    "restore-defaults": "Restore Defaults",
    "user-settings": "User Settings",
    "delete-account": "Delete Account",
    "delete-account-description":
      "All songs and accounts stored in the cloud will be deleted. Once deleted, the data cannot be restored. If you really want to execute the deletion, press the Delete button.",
    /* AutoSaveDialog */
    "auto-save-dialog-title": "Restore Auto Saved Song",
    "auto-save-dialog-description":
      "An auto-saved song from your last session was found. Do you want to restore it?",
    "auto-save-dialog-last-save-time": "Last saved at:",
    "auto-save-dialog-restore": "Restore",
    "auto-save-dialog-delete": "Delete",
    /* MIDI Instrument Categories */
    Piano: "鋼琴",
    "Chromatic Percussion": "固定音高敲擊樂器",
    Organ: "風琴",
    Guitar: "吉他",
    Bass: "貝斯",
    Strings: "弦樂器",
    Ensemble: "合奏",
    Brass: "銅管樂器",
    Reed: "簧樂器",
    Pipe: "管樂器",
    "Synth Lead": "合成音主旋律",
    "Synth Pad": "合成音和弦襯底",
    "Synth Effects": "合成音效果",
    Ethnic: "民族樂器",
    Percussive: "打擊樂器",
    "Sound Effects": "特殊音效",
    "Drum Kits": "Drum Kits",
    /* MIDI Instruments */
    /* 翻訳参考：https://zh.wikipedia.org/zh-tw/General_MIDI */
    "Acoustic Grand Piano": "平臺鋼琴",
    "Bright Acoustic Piano": "亮音鋼琴",
    "Electric Grand Piano": "電鋼琴",
    "Honky-tonk Piano": "酒吧鋼琴",
    "Electric Piano 1": "電鋼琴1",
    "Electric Piano 2": "電鋼琴2",
    Harpsichord: "大鍵琴",
    Clavinet: "電翼琴",
    Celesta: "鋼片琴",
    Glockenspiel: "鐘琴",
    "Music Box": "音樂盒",
    Vibraphone: "顫音琴",
    Marimba: "馬林巴琴",
    Xylophone: "木琴",
    "Tubular Bells": "管鐘",
    Dulcimer: "洋琴",
    "Drawbar Organ": "音栓風琴",
    "Percussive Organ": "敲擊風琴",
    "Rock Organ": "搖滾風琴",
    "Church Organ": "教堂管風琴",
    "Reed Organ": "簧風琴",
    Accordion: "手風琴",
    Harmonica: "口琴",
    "Tango Accordion": "探戈手風琴",
    "Acoustic Guitar (nylon)": "木吉他（尼龍弦）",
    "Acoustic Guitar (steel)": "木吉他（鋼弦）",
    "Electric Guitar (jazz)": "電吉他（爵士）",
    "Electric Guitar (clean)": "電吉他（原音）",
    "Electric Guitar (muted)": "電吉他（悶音）",
    "Overdriven Guitar": "電吉他（破音）",
    "Distortion Guitar": "電吉他（失真）",
    "Guitar Harmonics": "吉他泛音",
    "Acoustic Bass": "民謠貝斯",
    "Electric Bass (finger)": "電貝斯（指奏）",
    "Electric Bass (pick)": "電貝斯（撥奏）",
    "Fretless Bass": "無格貝斯",
    "Slap Bass 1": "捶鉤貝斯1",
    "Slap Bass 2": "捶鉤貝斯2",
    "Synth Bass 1": "合成貝斯1",
    "Synth Bass 2": "合成貝斯2",
    Violin: "小提琴",
    Viola: "中提琴",
    Cello: "大提琴",
    Contrabass: "低音大提琴",
    "Tremolo Strings": "顫弓弦樂",
    "Pizzicato Strings": "彈撥弦樂",
    "Orchestral Harp": "豎琴",
    Timpani: "定音鼓",
    "String Ensemble 1": "弦樂合奏1",
    "String Ensemble 2": "弦樂合奏2",
    "Synth Strings 1": "合成弦樂1",
    "Synth Strings 2": "合成弦樂2",
    "Choir Aahs": "人聲「啊」",
    "Voice Oohs": "人聲「喔」",
    "Synth Choir": "合成人聲",
    "Orchestra Hit": "交響打擊樂",
    Trumpet: "小號",
    Trombone: "長號",
    Tuba: "低音號",
    "Muted Trumpet": "悶音小號",
    "French Horn": "法國號",
    "Brass Section": "銅管樂",
    "Synth Brass 1": "合成銅管1",
    "Synth Brass 2": "合成銅管2",
    "Soprano Sax": "高音薩克斯風",
    "Alto Sax": "中音薩克斯風",
    "Tenor Sax": "次中音薩克斯風",
    "Baritone Sax": "上低音薩克斯風",
    Oboe: "雙簧管",
    "English Horn": "英國管",
    Bassoon: "低音管",
    Clarinet: "單簧管",
    Piccolo: "短笛",
    Flute: "長笛",
    Recorder: "直笛",
    "Pan Flute": "排簫",
    "Blown Bottle": "瓶笛",
    Shakuhachi: "尺八",
    Whistle: "口哨",
    Ocarina: "陶笛",
    "Lead 1 (square)": "方波",
    "Lead 2 (sawtooth)": "鋸齒波",
    "Lead 3 (calliope)": "汽笛風琴",
    "Lead 4 (chiff)": "合成吹管",
    "Lead 5 (charang)": "合成電吉他",
    "Lead 6 (voice)": "人聲鍵盤",
    "Lead 7 (fifths)": "五度音",
    "Lead 8 (bass + lead)": "貝斯吉他合奏",
    "Pad 1 (new age)": "新世紀",
    "Pad 2 (warm)": "溫暖",
    "Pad 3 (polysynth)": "多重合音",
    "Pad 4 (choir)": "人聲合唱",
    "Pad 5 (bowed)": "玻璃",
    "Pad 6 (metallic)": "金屬",
    "Pad 7 (halo)": "光暈",
    "Pad 8 (sweep)": "掃弦",
    "FX 1 (rain)": "雨",
    "FX 2 (soundtrack)": "電影音效",
    "FX 3 (crystal)": "水晶",
    "FX 4 (atmosphere)": "氣氛",
    "FX 5 (brightness)": "明亮",
    "FX 6 (goblins)": "魅影",
    "FX 7 (echoes)": "回音",
    "FX 8 (sci-fi)": "科幻",
    Sitar: "西塔琴",
    Banjo: "斑鳩琴",
    Shamisen: "三味線",
    Koto: "古箏",
    Kalimba: "卡林巴鐵片琴",
    Bagpipe: "蘇格蘭風笛",
    Fiddle: "古提琴",
    Shanai: "印度嗩吶",
    "Tinkle Bell": "叮噹鈴",
    Agogo: "阿哥哥鼓",
    "Steel Drums": "鋼鼓",
    Woodblock: "木魚",
    "Taiko Drum": "太鼓",
    "Melodic Tom": "定音筒鼓",
    "Synth Drum": "合成鼓",
    "Reverse Cymbal": "逆轉鈸聲",
    "Guitar Fret Noise": "吉他滑弦雜音",
    "Breath Noise": "呼吸雜音",
    Seashore: "海岸",
    "Bird Tweet": "鳥鳴",
    "Telephone Ring": "電話鈴聲",
    Helicopter: "直升機",
    Applause: "拍手",
    Gunshot: "槍聲",
    /* Drum Kit Instruments */
    "Standard Drum Kit": "Standard Drum Kit",
    "Room Drum Kit": "Room Drum Kit",
    "Power Drum Kit": "Power Drum Kit",
    "Electronic Drum Kit": "Electronic Drum Kit",
    "Analog Drum Kit": "Analog Drum Kit",
    "Jazz Drum Kit": "Jazz Drum Kit",
    "Brush Drum Kit": "Brush Drum Kit",
    "Orchestra Drum Kit": "Orchestra Drum Kit",
    "SFX Drum Kit": "SFX Drum Kit",
    /* */
    velocity: "力度控制",
    "pitch-bend": "滑音控制",
    volume: "音量控制",
    panpot: "相位控制",
    expression: "表情控制",
    "hold-pedal": "延音控制",
    pan: "相位",
    event: "事件",
    duration: "持續",
    tick: "起始",
    value: "值",
    key: "Key",
    scale: "Scale",
    "show-scale": "Show Scale",
    "hide-scale": "Hide Scale",
    /* Scale */
    "scale-major": "Major",
    "scale-minor": "Minor",
    "scale-harmonic-minor": "Harmonic Minor",
    "scale-harmonic-major": "Harmonic Major",
    "scale-melodic-minor": "Melodic Minor",
    "scale-ionian": "Ionian",
    "scale-dorian": "Dorian",
    "scale-phrygian": "Phrygian",
    "scale-lydian": "Lydian",
    "scale-mixolydian": "Mixolydian",
    "scale-aeolian": "Aeolian",
    "scale-locrian": "Locrian",
    "scale-major-pentatonic": "Major Pentatonic",
    "scale-minor-pentatonic": "Minor Pentatonic",
    "scale-major-blues": "Major Blues",
    "scale-minor-blues": "Minor Blues",
    "scale-half-whole-diminished": "Half-whole Diminished",
    "scale-whole-half-diminished": "Whole-half Diminished",
    "scale-whole-tone": "Whole Tone",
    /* operation */
    "operation-set": "Set",
    "operation-add": "Add",
    "operation-multiply": "Multiply",
  },
  sk: {
    "piano-roll": "Piano Roll",
    tempo: "Tempo",
    "time-signature": "Taktové označenie",
    "add-time-signature": "Pridať taktové označenie",
    "remove-time-signature": "Odstrániť taktové označenie",
    file: "Súbor",
    edit: "Upraviť",
    "new-song": "Nový",
    "open-song": "Otvoriť",
    "save-song": "Uložiť",
    "save-as": "Uložiť ako",
    "song-created": "Skladba vytvorená",
    "song-saving": "Ukladanie skladby...",
    "song-saved": "Skladba uložená",
    "download-midi": "Stiahnuť MIDI súbor",
    "untitled-song": "Nepomenovaná skladba",
    name: "Názov",
    rename: "Premenovať",
    track: "Stopa",
    "add-track": "Pridať stopu",
    "delete-track": "Odstrániť stopu",
    "duplicate-track": "Duplikovať stopu",
    channel: "Kanál",
    categories: "Kategórie",
    instruments: "Nástroje",
    "rhythm-track": "Rytmická stopa",
    "conductor-track": "Dirigentská stopa",
    "track-name": "Názov stopy",
    "midi-routing": "Smerovanie",
    "midi-routing-selected-track": "Aktívna stopa",
    "midi-routing-selected-track-description":
      "Odosiela všetky vstupy MIDI na aktuálne vybranú stopu",
    "midi-routing-channel": "Viac stôp",
    "midi-routing-channel-description":
      "Smeruje vstupy na stopy podľa kanála MIDI pre súčasné nahrávanie viacerých stôp",
    cancel: "Zrušiť",
    insert: "Vložiť",
    ok: "OK",
    reset: "Resetovať",
    triplet: "Triola",
    dotted: "S bodkou",
    "confirm-new": "Vaše úpravy neboli uložené. Naozaj chcete pokračovať?",
    "confirm-open": "Vaše úpravy neboli uložené. Naozaj chcete pokračovať?",
    "confirm-close":
      "Vaše úpravy neboli uložené. Pred zatvorením si ich nezabudnite stiahnuť. Naozaj chcete zatvoriť?",
    "auto-scroll": "Automatické posúvanie",
    help: "Pomoc",
    close: "Zatvoriť",
    "keyboard-shortcut": "Klávesové skratky",
    "play-pause": "Prehrať/Pozastaviť",
    rewind: "Pretočiť späť",
    "fast-forward": "Rýchle pretočenie",
    "forward-rewind": "Pretočiť späť / Dopredu",
    "start-stop-recording": "Spustiť/Zastaviť nahrávanie",
    "next-previous-track": "Nasledujúca stopa / Predchádzajúca stopa",
    "solo-mute-ghost": "Solo, Stíšiť alebo Skryť stopu",
    stop: "Zastaviť",
    record: "Nahrávať",
    "pencil-tool": "Nástroj ceruzka",
    "selection-tool": "Nástroj výber",
    "control-pencil-tool": "Voľné",
    "control-single-tool": "Jediný",
    "control-line-tool": "Čiara",
    "control-curve-tool": "Krivka",
    "curve-ease-in": "Krivka zrýchlenia",
    "curve-ease-out": "Krivka spomalenia",
    "copy-selection": "Kopírovať výber",
    "cut-selection": "Vystrihnúť výber",
    "paste-selection": "Vložiť výber",
    "select-all": "Vybrať všetko",
    "select-next": "Vybrať nasledujúce",
    "select-previous": "Vybrať predchádzajúce",
    "delete-selection": "Odstrániť výber",
    "move-selection": "Presunúť výber",
    undo: "Späť",
    redo: "Znovu",
    cut: "Vystrihnúť",
    copy: "Kopírovať",
    copied: "Skopírované",
    paste: "Vložiť",
    duplicate: "Duplikovať",
    delete: "Odstrániť",
    "song-deleted": "Skladba odstránená",
    "song-delete-failed": "Odstránenie skladby zlyhalo",
    "select-note": "Vybrať notu",
    "scroll-horizontally": "Posúvať horizontálne",
    "scroll-vertically": "Posúvať vertikálne",
    settings: "Nastavenia",
    language: "Jazyk",
    theme: "Téma",
    "midi-settings": "MIDI nastavenia",
    inputs: "Vstupy",
    outputs: "Výstupy",
    "no-inputs": "Nenájdené žiadne vstupné zariadenia",
    "one-octave-up": "+1 oktáva",
    "one-octave-down": "-1 oktáva",
    arrange: "Usporiadať",
    "arrangement-view": "Pohľad usporiadania",
    "open-help": "Otvoriť pomoc",
    "event-list": "Zoznam udalostí",
    "open-chat": "Otvoriť chat",
    property: "Vlastnosť",
    quantize: "Kvantizovať",
    "snap-to-grid": "Prichytiť k mriežke",
    "export-audio": "Exportovať audio",
    export: "Exportovať",
    "exporting-audio": "Exportovanie audia...",
    "file-type": "Typ súboru",
    "export-error-too-short": "Skladba je príliš krátka",
    "set-loop-start": "Nastaviť začiatok slučky",
    "set-loop-end": "Nastaviť koniec slučky",
    "switch-tab": "Prepnúť záložku",
    transpose: "Transponovať",
    yes: "Áno",
    no: "Nie",
    "please-sign-up": "Zaregistrujte sa na používanie cloudového ukladania",
    "save-changes": "Chcete uložiť zmeny v skladbe?",
    "sign-in": "Prihlásiť sa",
    "sign-out": "Odhlásiť sa",
    "success-sign-in": "Úspešne prihlásený",
    files: "Súbory",
    "created-date": "Vytvorené",
    "modified-date": "Upravené",
    "cloud-beta-warning":
      "Keďže cloudová funkcia je v beta verzii počas vývoja, často si sťahujte a ukladajte svoje dôležité skladby.",
    "cloud-description":
      "Prihlásením sa môžete uložiť svoju hudbu do cloudu a pokračovať v komponovaní odkiaľkoľvek a kedykoľvek.",
    "import-midi": "Importovať MIDI",
    "export-midi": "Exportovať MIDI",
    general: "Všeobecné",
    appearance: "Vzhľad",
    "change-track-color": "Zmeniť farbu stopy",
    "control-settings": "Nastavenia ovládania",
    "show-note-labels": "Zobraziť označenia nôt",
    add: "Pridať",
    remove: "Odstrániť",
    "initialize-error": "Chyba pri spúšťacom procese",
    "soundfont-save-notice": "SoundFont bude uložený v prehliadači.",
    "loading-external-midi": "Načítavanie externého MIDI súboru...",
    initializing: "Inicializácia...",
    profile: "Profil",
    "publish-notice":
      "Publikovanie vašej skladby ju sprístupní ostatným používateľom na počúvanie.",
    "published-notice":
      "Vaša skladba je publikovaná a dostupná ostatným používateľom na počúvanie.",
    publish: "Publikovať",
    unpublish: "Zrušiť publikovanie",
    "publish-song": "Publikovať skladbu",
    "song-published": "Skladba publikovaná",
    "song-unpublished": "Publikovanie skladby zrušené",
    "share-my-song-text":
      "🎶 Práve som vytvoril novú skladbu na signal! 🎹✨\nPočúvajte moju najnovšiu MIDI kompozíciu! 🎧👇\n#midi #signalmidi @signalmidi",
    "publish-rules":
      "Dôležité upozornenie: Na tejto stránke povoľujeme iba zverejňovanie hudby, ktorú ste vytvorili sami. V súlade s autorskými zákonmi sa uistite, že ste držiteľom autorských práv alebo máte výslovné povolenie na akúkoľvek hudbu, ktorú zverejňujete. Neoprávnené publikovanie cudzej hudby alebo diel chránených autorskými právami je zákonmi zakázané. Ak sa takéto porušenia objavia, váš príspevok môže byť odstránený a na váš účet môžu byť uvalené obmedzenia. Povzbudzujeme vás, aby ste zdieľali kreatívne a originálne diela a prispievali k zdravému rastu našej komunity.",
    "soundfont-location": "Umiestnenie",
    "loading-file": "Načítavanie súboru...",
    soundfont: "SoundFont",
    scan: "Skenovať",
    midi: "MIDI",
    "no-files": "Žiadne súbory",
    "restore-defaults": "Obnoviť predvolené",
    "user-settings": "Používateľské nastavenia",
    "delete-account": "Odstrániť účet",
    "delete-account-description":
      "Všetky skladby a účty uložené v cloude budú odstránené. Po odstránení sa údaje nedajú obnoviť. Ak naozaj chcete vykonať odstránenie, stlačte tlačidlo Odstrániť.",
    /* AutoSaveDialog */
    "auto-save-dialog-title": "Obnoviť automaticky uloženú skladbu",
    "auto-save-dialog-description":
      "Bola nájdená automaticky uložená skladba z vašej poslednej relácie. Chcete ju obnoviť?",
    "auto-save-dialog-last-save-time": "Naposledy uložené:",
    "auto-save-dialog-restore": "Obnoviť",
    "auto-save-dialog-delete": "Odstrániť",
    /* MIDI Instrument Categories */
    Piano: "Piano",
    "Chromatic Percussion": "Chromatické perkusie",
    Organ: "Organ",
    Guitar: "Gitara",
    Bass: "Bas",
    Strings: "Sláčiky",
    Ensemble: "Súbor",
    Brass: "Žesťové",
    Reed: "Jazýčkové",
    Pipe: "Píšťaly",
    "Synth Lead": "Synth Lead",
    "Synth Pad": "Synth Pad",
    "Synth Effects": "Synth efekty",
    Ethnic: "Etnické",
    Percussive: "Perkusívne",
    "Sound Effects": "Zvukové efekty",
    "Drum Kits": "Bicí súpravy",
    /* MIDI Instruments */
    "Acoustic Grand Piano": "Akustické krídlo",
    "Bright Acoustic Piano": "Jasné akustické piano",
    "Electric Grand Piano": "Elektrické krídlo",
    "Honky-tonk Piano": "Honky-tonk piano",
    "Electric Piano 1": "Elektrické piano 1",
    "Electric Piano 2": "Elektrické piano 2",
    Harpsichord: "Čembalo",
    Clavinet: "Klavinet",
    Celesta: "Celesta",
    Glockenspiel: "Zvonkohra",
    "Music Box": "Hracia skrinka",
    Vibraphone: "Vibrafón",
    Marimba: "Marimba",
    Xylophone: "Xylofón",
    "Tubular Bells": "Rúrkové zvony",
    Dulcimer: "Cimbal",
    "Drawbar Organ": "Ťažný organ",
    "Percussive Organ": "Perkusívny organ",
    "Rock Organ": "Rockový organ",
    "Church Organ": "Kostolný organ",
    "Reed Organ": "Jazýčkový organ",
    Accordion: "Akordeón",
    Harmonica: "Harmonika",
    "Tango Accordion": "Tango akordeón",
    "Acoustic Guitar (nylon)": "Akustická gitara (nylon)",
    "Acoustic Guitar (steel)": "Akustická gitara (oceľ)",
    "Electric Guitar (jazz)": "Elektrická gitara (jazz)",
    "Electric Guitar (clean)": "Elektrická gitara (čistá)",
    "Electric Guitar (muted)": "Elektrická gitara (stlmená)",
    "Overdriven Guitar": "Predbudenou gitara",
    "Distortion Guitar": "Distorzná gitara",
    "Guitar Harmonics": "Gitarové harmonické",
    "Acoustic Bass": "Akustický bas",
    "Electric Bass (finger)": "Elektrický bas (prsty)",
    "Electric Bass (pick)": "Elektrický bas (trsátko)",
    "Fretless Bass": "Bezpražcový bas",
    "Slap Bass 1": "Slap bas 1",
    "Slap Bass 2": "Slap bas 2",
    "Synth Bass 1": "Synth bas 1",
    "Synth Bass 2": "Synth bas 2",
    Violin: "Husle",
    Viola: "Viola",
    Cello: "Violončelo",
    Contrabass: "Kontrabas",
    "Tremolo Strings": "Tremolo sláčiky",
    "Pizzicato Strings": "Pizzicato sláčiky",
    "Orchestral Harp": "Orchestrálna harfa",
    Timpani: "Tympany",
    "String Ensemble 1": "Sláčikový súbor 1",
    "String Ensemble 2": "Sláčikový súbor 2",
    "Synth Strings 1": "Synth sláčiky 1",
    "Synth Strings 2": "Synth sláčiky 2",
    "Choir Aahs": "Zbor Aahs",
    "Voice Oohs": "Hlas Oohs",
    "Synth Choir": "Synth zbor",
    "Orchestra Hit": "Orchestrálny úder",
    Trumpet: "Trúbka",
    Trombone: "Pozauna",
    Tuba: "Tuba",
    "Muted Trumpet": "Stlmená trúbka",
    "French Horn": "Lesný roh",
    "Brass Section": "Žesťová sekcia",
    "Synth Brass 1": "Synth žesťové 1",
    "Synth Brass 2": "Synth žesťové 2",
    "Soprano Sax": "Sopránový saxofón",
    "Alto Sax": "Altový saxofón",
    "Tenor Sax": "Tenorový saxofón",
    "Baritone Sax": "Barytónový saxofón",
    Oboe: "Hoboj",
    "English Horn": "Anglický roh",
    Bassoon: "Fagot",
    Clarinet: "Klarinet",
    Piccolo: "Pikola",
    Flute: "Flauta",
    Recorder: "Zobcová flauta",
    "Pan Flute": "Panová flauta",
    "Blown Bottle": "Fúkaná fľaša",
    Shakuhachi: "Šakuhači",
    Whistle: "Píšťalka",
    Ocarina: "Okarína",
    "Lead 1 (square)": "Lead 1 (štvorec)",
    "Lead 2 (sawtooth)": "Lead 2 (píla)",
    "Lead 3 (calliope)": "Lead 3 (kalliope)",
    "Lead 4 (chiff)": "Lead 4 (chiff)",
    "Lead 5 (charang)": "Lead 5 (charang)",
    "Lead 6 (voice)": "Lead 6 (hlas)",
    "Lead 7 (fifths)": "Lead 7 (kvinty)",
    "Lead 8 (bass + lead)": "Lead 8 (bas + lead)",
    "Pad 1 (new age)": "Pad 1 (new age)",
    "Pad 2 (warm)": "Pad 2 (teplý)",
    "Pad 3 (polysynth)": "Pad 3 (polysynth)",
    "Pad 4 (choir)": "Pad 4 (zbor)",
    "Pad 5 (bowed)": "Pad 5 (sláčikový)",
    "Pad 6 (metallic)": "Pad 6 (kovový)",
    "Pad 7 (halo)": "Pad 7 (halo)",
    "Pad 8 (sweep)": "Pad 8 (sweep)",
    "FX 1 (rain)": "FX 1 (dážď)",
    "FX 2 (soundtrack)": "FX 2 (soundtrack)",
    "FX 3 (crystal)": "FX 3 (krištáľ)",
    "FX 4 (atmosphere)": "FX 4 (atmosféra)",
    "FX 5 (brightness)": "FX 5 (jas)",
    "FX 6 (goblins)": "FX 6 (škriatkovia)",
    "FX 7 (echoes)": "FX 7 (ozveny)",
    "FX 8 (sci-fi)": "FX 8 (sci-fi)",
    Sitar: "Sitár",
    Banjo: "Bendžo",
    Shamisen: "Šamisen",
    Koto: "Koto",
    Kalimba: "Kalimba",
    Bagpipe: "Gajdy",
    Fiddle: "Husle (ľudové)",
    Shanai: "Šanaj",
    "Tinkle Bell": "Zvonček",
    Agogo: "Agogo",
    "Steel Drums": "Oceľové bubny",
    Woodblock: "Drevený blok",
    "Taiko Drum": "Taiko bubon",
    "Melodic Tom": "Melodický tom",
    "Synth Drum": "Synth bubon",
    "Reverse Cymbal": "Obrátený činel",
    "Guitar Fret Noise": "Šum gitarových pražcov",
    "Breath Noise": "Šum dychu",
    Seashore: "Morský breh",
    "Bird Tweet": "Štebotanie vtákov",
    "Telephone Ring": "Zvonenie telefónu",
    Helicopter: "Helikoptéra",
    Applause: "Potlesk",
    Gunshot: "Výstrel",
    /* Drum Kit Instruments */
    "Standard Drum Kit": "Štandardná bicí súprava",
    "Room Drum Kit": "Miestnosť bicí súprava",
    "Power Drum Kit": "Power bicí súprava",
    "Electronic Drum Kit": "Elektronická bicí súprava",
    "Analog Drum Kit": "Analógová bicí súprava",
    "Jazz Drum Kit": "Jazzová bicí súprava",
    "Brush Drum Kit": "Kefová bicí súprava",
    "Orchestra Drum Kit": "Orchestrálna bicí súprava",
    "SFX Drum Kit": "SFX bicí súprava",
    /* */
    velocity: "Rýchlosť",
    "pitch-bend": "Ohyb výšky tónu",
    volume: "Hlasitosť",
    panpot: "Panoráma",
    expression: "Výraz",
    "hold-pedal": "Pedál držania",
    pan: "Panoráma",
    event: "Udalosť",
    duration: "Trvanie",
    tick: "Tick",
    value: "Hodnota",
    key: "Kľúč",
    scale: "Stupnica",
    "show-scale": "Zobraziť stupnicu",
    "hide-scale": "Skryť stupnicu",
    /* Scale */
    "scale-major": "Dur",
    "scale-minor": "Mol",
    "scale-harmonic-minor": "Harmonický mol",
    "scale-harmonic-major": "Harmonický dur",
    "scale-melodic-minor": "Melodický mol",
    "scale-ionian": "Iónsky",
    "scale-dorian": "Dórsky",
    "scale-phrygian": "Frýgsky",
    "scale-lydian": "Lýdsky",
    "scale-mixolydian": "Mixolýdsky",
    "scale-aeolian": "Aiolsky",
    "scale-locrian": "Lokrský",
    "scale-major-pentatonic": "Dur pentatonická",
    "scale-minor-pentatonic": "Mol pentatonická",
    "scale-major-blues": "Dur blues",
    "scale-minor-blues": "Mol blues",
    "scale-half-whole-diminished": "Pol-celý zmenšený",
    "scale-whole-half-diminished": "Celý-pol zmenšený",
    "scale-whole-tone": "Celotónová",
    /* operation */
    "operation-set": "Nastaviť",
    "operation-add": "Pridať",
    "operation-multiply": "Násobiť",
  },
} as const
